import { render, staticRenderFns } from "./ShopDashboard.vue?vue&type=template&id=4ba3a3a8"
import script from "./ShopDashboard.vue?vue&type=script&lang=js"
export * from "./ShopDashboard.vue?vue&type=script&lang=js"
import style0 from "./ShopDashboard.vue?vue&type=style&index=0&id=4ba3a3a8&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/TypXw3yGP/0/DHCCorporation/dhc-cloud-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ba3a3a8')) {
      api.createRecord('4ba3a3a8', component.options)
    } else {
      api.reload('4ba3a3a8', component.options)
    }
    module.hot.accept("./ShopDashboard.vue?vue&type=template&id=4ba3a3a8", function () {
      api.rerender('4ba3a3a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/ShopDashboard.vue"
export default component.exports